import { isVisibleSegment } from '../utils/isVisibleSegment';
import type { ParsedWordSegment } from '../types';

/**
 * Phase 2: Word Segmentation
 *
 * Use Intl.Segmenter to split text into word segments.
 * This handles international text correctly, including:
 * - CJK (Chinese, Japanese, Korean) characters
 * - Complex emojis and emoji sequences
 * - Ligatures and accented characters
 * - Mixed languages and scripts
 */
export const segmentWords = (
  segmenter: Intl.Segmenter,
  text: string,
): Array<ParsedWordSegment> => {
  const segments = Array.from(segmenter.segment(text));

  return segments.map(segment => ({
    data: segment.segment,
    start: segment.index,
    end: segment.index + segment.segment.length,
    isWordLike: segment.isWordLike,
    isVisible: isVisibleSegment(segment.segment),
  }));
};
